export const MAX_SAMPLES_PER_BATCH = 20
